import React from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet";

const OrderView = () => {
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Orders | ATG Staff</title>
      </Helmet>
      <Outlet />
    </React.Fragment>
  );
};

export default OrderView;
